
import {Uploader} from 'vant';
import 'vant/lib/uploader/style'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
name: 'step1',
components: {
XTextarea,
TransferDom,
XHeader,
XButton,
Popup,
Swipeout, SwipeoutItem, SwipeoutButton,
XAddress,
XInput,
XSwitch,
Group,
Flow, FlowState, FlowLine,
Uploader
},
data() {
return {
limitNumber: 999,
action: 'add',
addressList: [],

showAddressList: false,

showEditAddress: false,
formData: {
name: '',
no: '',
region: '',
},
addressData: [],
idCard: [],
contract: []
}
},
created: function () {
this.getCity()
},
methods: {
download() {
window.location.href = 'http://ty.mytyhl.net/1.zip'
},
getCity() {
const url = this.tianYiWebUrl + '/wechat/address/ajaxGetChinaCity';
this.$http.get(url).then(r => {
this.addressData = r.data;
this.$vux.loading.hide()
})
},
next() {
this.$vux.loading.show({
text: '处理中...'
});
console.log(this.formData, this.idCard, this.contract)

this.$http.post(this.tianYiWebUrl + '/wechat/uc/sellerRequest', {
idCard: this.idCard,
contract: this.contract,
info: this.formData
}).then((r) => {
this.$vux.loading.hide();
if (r.data.code === 200) {
if (r.data.data === 1) {
this.$router.push('/uc/seller-request?step=2')
}
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/components/sellerRequest/step1.vue